module.exports = __webpack_public_path__ + "media/images/media_cover_img-e652456c17da938f93202566a978e87b.svg";